/** @format */

import { GetTypeRequestInterface, PlkField } from './PlkTypesInterface';
import MvnoOperation from '../../interfaces/platform/MvnoOperation';
import { PlusOrdersCommonResponse } from '../../interfaces/platform/PlusOrdersCommonResponse';
import GetFeatureDetailsForSubscription from './GetFeatureDetailsForSubscription';
import { DateHelper } from '../../helpers/DateHelper';

const _ = require('underscore');

export interface GetSubscriptionRequest extends GetTypeRequestInterface {
    subscriptionName: string;
}

export default class GetSubscriptionEntity {
    protected request: GetSubscriptionRequest | GetFeatureDetailsForSubscription;

    protected operation: MvnoOperation;

    constructor(operation: MvnoOperation) {
        this.operation = operation;
        this.request = JSON.parse(operation.eventsJson) as GetSubscriptionRequest;
    }

    getRequestParameter = (index: number): Array<PlkField> => {
        const request = this.getPlusOrdersCommonResponse(index);
        let obj: Array<PlkField> = [];
        obj.push({ key: 'createdAt', value: DateHelper.format(request.createdAt) });
        _.map(this.request, (val: string, key: string) => {
            obj.push({ key: key, value: val });
        });
        return obj;
    };

    getResponseParameter = (index: number): Array<PlkField> => {
        let obj: Array<PlkField> = [];
        const response = this.getPlusOrdersCommonResponse(index);
        obj.push({ key: 'responseTime', value: DateHelper.format(response.responseTime) });
        const responseJsonObject = JSON.parse(response.messageJson);
        _.map(responseJsonObject, (val: string, key: string) => {
            if (key !== 'XML_RESPONSE' && key !== 'XML_REQUEST') {
                if (key !== 'items') {
                    obj.push({ key: key, value: val });
                } else {
                    let items: Array<PlkField> = [];
                    for (let i = 0; i < val.length; i++) {
                        _.map(val[i], (v1: string, k1: string) => {
                            items.push({ key: k1, value: v1 });
                        });
                    }
                    obj.push({ key: key, value: items });
                }
            }
        });
        return obj;
    };

    getPlusOrdersCommonResponse = (index: number): PlusOrdersCommonResponse => {
        return this.operation.tableResponse[index];
    };
}
